import React, {useState, useEffect, useContext} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Button, Checkbox, Col, Drawer, Form, Input, Row, Table} from 'antd';
import {useInput} from '../../../../../shared/hooks/useInput';
import {useDrawerVisibility} from '../../../../../shared/hooks/useDrawerVisibility';
import {ApiMotivationService} from '../../../../../shared/api/motivation/motivation.service';
import {TableActionColumn} from '../../components/TableActionColumn/TableActionColumn';
import {Context} from '../../../../../shared/context/context';
import {ApiContentService} from "../../../../../shared/api/content/content.service";
import {countText, SectionToolbar, useSectionSearch} from "../../components/SectionToolbar/SectionToolbar";
import {useCanEdit} from "../../../sectionAccess";

const joined = (value) => (Array.isArray(value) ? value.join(', ') : value)

const column = [
  {title: 'ID', dataIndex: 'id', width: 80},
  {title: 'Застройщик', dataIndex: 'name'},
  {title: 'Объект', dataIndex: 'object'},
  {title: 'Вознаграждение', dataIndex: 'rewards', render: joined},
  {title: 'Срок выплаты', dataIndex: 'paymentTerm', render: joined},
  {
    title: 'Действия',
    render: (row) => (
      <TableActionColumn
        onDeleteButtonClick={() => ApiMotivationService.deleteMotivation(row.id)}
        payloadOfFieldWhichWillBeUpdated={{motivationIdWhichWillBeUpdated: row.id}}
        editDrawerVisibility={{motivationDrawerVisibility: true}}
      />
    ),
  },
];


export const MotivationSection = () => {
  const canEdit = useCanEdit()

  const [newNameMotivation, handleNewNameMotivationValueChange] = useInput('');
  const [newNameObjectMotivation, handleNewNameObjectMotivationValueChange] = useInput('');
  const [rewardsMotivation, handleRewardsMotivationValueChange] = useState([]);
  const [paymentTermMotivation, handlePaymentTermMotivationValueChange] = useState([]);

  const [setDrawerVisibility] = useDrawerVisibility();
  const {state} = useContext(Context);
  const [isCreateModal, setIsCreateModal] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [search, setSearch, motivations] = useSectionSearch(tableData, ['name', 'object', 'rewards', 'paymentTerm']);
  const [rewardsOptions, setRewardsOptions] = useState([]);
  const [paymentTermOptions, setPaymentTermOptions] = useState([]);



  useEffect(() => {
    ApiContentService.fetchContents().then((response) => {
      const contents = response.data;
      setRewardsOptions(handlerContent(contents, 'rewardsMotivation'));
      setPaymentTermOptions(handlerContent(contents, 'paymentTerm'));
    });
  }, []);

  useEffect(() => {
    getMotivationsList()
  }, []);


  const handlerContent = (contents, contentName) => {
    const content = contents.find(content => content.name === contentName);
    return content.value.map(value => value.value);
  }

  const onChangeRewardsOptions = (checkedValues) => {
    handleRewardsMotivationValueChange(checkedValues);
  }

  const onChangePaymentTerm = (checkedValues) => {
    handlePaymentTermMotivationValueChange(checkedValues);
  }

  const submitNewMotivation = async () => {

    if (newNameMotivation && newNameObjectMotivation && rewardsMotivation.length && paymentTermMotivation.length) {
      const response = await ApiMotivationService.createMotivation(
        {
          name: newNameMotivation,
          object: newNameObjectMotivation,
          rewards: rewardsMotivation,
          paymentTerm: paymentTermMotivation,
        });

      const newMotivation = response.data;

      newMotivation.key = newMotivation.id;
      setTableData((prev) => [...prev, newMotivation]);
      setDrawerVisibility({motivationDrawerVisibility: false});
      setIsCreateModal(false);
    }
  };


  const updateMotivation = () => {

    if (newNameMotivation && newNameObjectMotivation && rewardsMotivation.length && paymentTermMotivation.length) {
      ApiMotivationService.changeMotivation(state.motivationIdWhichWillBeUpdated,
        {
          name: newNameMotivation,
          object: newNameObjectMotivation,
          rewards: rewardsMotivation,
          paymentTerm: paymentTermMotivation,
        });

      getMotivationsList()
      setDrawerVisibility({motivationDrawerVisibility: false})
    }
  };

  const getMotivationsList = () => {
    ApiMotivationService.fetchMotivations().then((response) => {
      const motivations = response.data.items;
      motivations.forEach((motivation) => (motivation.key = motivation.id));

      setTableData(motivations);
    });
  };


  return (
    <section className="builder-section">
      <Table
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder='Застройщик, объект или вознаграждение'
            count={countText(tableData.length, motivations.length, search)}
          >
            {canEdit && (
              <Button type="primary" icon={<PlusOutlined/>} onClick={() => {
                setIsCreateModal(true)
                setDrawerVisibility({motivationDrawerVisibility: true})
              }}>
                Добавить мотивацию
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={canEdit ? column : column.slice(0, -1)}
        dataSource={motivations}
        locale={{emptyText: 'Ничего не нашлось'}}
      />
      <Drawer
        title={isCreateModal ? "Новая мотивация" : "Изменить мотивацию"}
        width={720}
        onClose={() => {
          setIsCreateModal(false)
          setDrawerVisibility({motivationDrawerVisibility: false})
        }}
        visible={state.motivationDrawerVisibility}
        bodyStyle={{paddingBottom: 80}}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() =>{
              setIsCreateModal(false)
              setDrawerVisibility({motivationDrawerVisibility: false})
            }} style={{marginRight: 8}}>
              Отмена
            </Button>
            <Button onClick={isCreateModal ? submitNewMotivation : updateMotivation} type="primary">
              {isCreateModal ? "Добавить" : "Сохранить"}
            </Button>
          </div>
        }
      >
        <Form layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                style={{marginBottom: '10px'}}
                onChange={handleNewNameMotivationValueChange}
                placeholder="Застройщик"
                value={newNameMotivation}
              />
              <Input
                style={{marginBottom: '10px'}}
                onChange={handleNewNameObjectMotivationValueChange}
                placeholder="Объект"
                value={newNameObjectMotivation}
              />

              Вознаграждение
              <Checkbox.Group
                style={{marginBottom: '10px'}}
                options={rewardsOptions}
                onChange={onChangeRewardsOptions}
              />

              Срок выплаты <br/>
              <Checkbox.Group options={paymentTermOptions} onChange={onChangePaymentTerm}/>

            </Col>
          </Row>
        </Form>
      </Drawer>
    </section>
  )
}
